module.exports = __webpack_public_path__ + "assets/img/LTC012.73347545.png";